const ADMIN_PROXY_URL =
  "https://admin.lasgidirestaurant.com/php/proxy.php";

const REQUEST_TIMEOUT = 20000;

// ----------------------------
// Force logout
// ----------------------------
function forceLogout() {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("admin_expiresAt");
  localStorage.removeItem("admin_username");

  if (window.location.pathname !== "/") {
    window.location.href = "/";
  }
}

// ----------------------------
// Expiry check
// ----------------------------
function isTokenExpired() {
  const expiresAt = localStorage.getItem("admin_expiresAt");
  if (!expiresAt) return true;
  return Date.now() > Number(expiresAt);
}

async function safeJson(res) {
  return await res.json().catch(() => ({}));
}

// ----------------------------
// Main API helper
// ----------------------------
export async function adminApiRequest({
  script,
  data = {},
  formData = null,
}) {
  if (script !== "signin" && isTokenExpired()) {
    forceLogout();
    throw new Error("SESSION_EXPIRED");
  }

  const token = localStorage.getItem("admin_token");

  const controller = new AbortController();
  const timeoutId = setTimeout(
    () => controller.abort(),
    REQUEST_TIMEOUT
  );

  try {

    // =============================
    // FILE UPLOAD
    // =============================
    if (formData instanceof FormData) {

      formData.append("script", script);

      if (token && script !== "signin") {
        formData.append("api_token", token);
      }

      const res = await fetch(ADMIN_PROXY_URL, {
        method: "POST",
        body: formData,
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      const result = await safeJson(res);

      if (
        res.status === 401 ||
        result?.error === "Invalid or expired API token" ||
        result?.error === "Access denied"
      ) {
        forceLogout();
        throw new Error("UNAUTHORIZED");
      }

      return result;
    }

    // =============================
    // NORMAL REQUEST
    // =============================
    const payload = {
      script,
      data,
    };

    if (token && script !== "signin") {
      payload.api_token = token;
    }

    const res = await fetch(ADMIN_PROXY_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      signal: controller.signal,
    });

    clearTimeout(timeoutId);

    const result = await safeJson(res);

    if (
      res.status === 401 ||
      result?.error === "Invalid or expired API token" ||
      result?.error === "Access denied"
    ) {
      forceLogout();
      throw new Error("UNAUTHORIZED");
    }

    return result;

  } catch (err) {

    clearTimeout(timeoutId);

    if (err.name === "AbortError") {
      throw new Error("REQUEST_TIMEOUT");
    }

    if (err.message === "Failed to fetch") {
      throw new Error("NETWORK_ERROR");
    }

    throw err;
  }
}